<div #screen style="width:100%;height:100%"></div>
<div #projected style="display:none"><ng-content></ng-content></div>
